import { Divider, Stack, Typography } from '@mui/material';

import { AccountModel } from '@portal-clients/account';

import { tApp } from '@frontend/locales';
import { usePortalConfiguration, useUser } from '@frontend/utils';

export interface AccountDetailsInfoProps {
  account: AccountModel;
}

export const AccountDetailsInfo = (props: AccountDetailsInfoProps) => {
  const { user } = useUser();
  const {
    config: { organizationDisplayName, operatorDisplayName },
  } = usePortalConfiguration();

  return (
    <Stack spacing={2} alignContent="start" direction={'column'}>
      <Stack spacing={1} alignContent="start" direction={'column'}>
        <Typography variant="body1">
          {props.account.displayName}{' '}
          {props.account.type === 'CREDIT'
            ? tApp.accountCard.credit()
            : props.account.type === 'PREPAID'
              ? tApp.accountDetails.prepaid()
              : tApp.accountCard.direct()}
        </Typography>
        {props.account.costCenter?.displayName && (
          <Typography variant="subtitle1" color="textSecondary">
            {props.account.costCenter.displayName}
          </Typography>
        )}
      </Stack>

      <Divider />
      <Stack spacing={1} alignContent="start" direction={'column'}>
        <Typography variant="body1" color="textSecondary">
          {organizationDisplayName}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {operatorDisplayName}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {user.client.displayName}
        </Typography>
      </Stack>
    </Stack>
  );
};
